import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "rdvLevel", "meetingDate"]

  connect() {
    this.toggleMeetingFields()
  }

  toggleMeetingFields() {
    const isMeeting = this.typeSelectTarget.value === "meeting"
    this.rdvLevelTarget.classList.toggle("hidden", !isMeeting)
    if (this.hasMeetingDateTarget) {
      this.meetingDateTarget.classList.toggle("hidden", !isMeeting)
      // Toggle required sur l'input date — required sur un champ hidden bloque
      // le submit côté navigateur sans message visible. Donc on ajoute/retire
      // dynamiquement selon le type d'activité.
      const dateInput = this.meetingDateTarget.querySelector("input[type='date']")
      if (dateInput) dateInput.required = isMeeting
    }
  }

  // Alias rétrocompat — certaines vues appellent encore toggleRdvLevel
  toggleRdvLevel() {
    this.toggleMeetingFields()
  }
}
